import React from 'react';
export const Footer = () => {
  return <footer className="bg-navy-900 text-gray-400 py-12 border-t border-white/5 text-center text-sm" data-id="element-72">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-73">
        <p className="mb-4" data-id="element-74">
          © 2025 FastLearnersOfficial — All Rights Reserved. Unauthorized
          reproduction and redistribution strictly prohibited.
        </p>
        <p className="text-xs text-gray-500 max-w-3xl mx-auto leading-relaxed" data-id="element-75">
          Our products and content are strictly educational and informational in
          nature. Individual results vary and depend entirely on the commitment,
          skills and personal application of each user.
        </p>
      </div>
    </footer>;
};